import { useAnySheetOpen } from './widgets.jsx';
import { FloatingBottomNav } from './floating-bottom-nav.jsx';

// Maps the area accent keyword to its CSS-variable (drives glow/identity only).
const ACCENT_VAR = {
  online: 'var(--accent-online)',
  flea: 'var(--accent-troedel)',
};

/**
 * Area bottom-nav (Online-Store + Troedel). Thin adapter over the shared
 * FloatingBottomNav — keeps its existing prop signature and self-guard so the
 * callers (online-store.jsx, troedel.jsx) stay unchanged.
 */
export default function BottomNav({
  tabs,
  activeTab,
  onChange,
  accent = 'online',
  dark,
  swipeProgress = 0,
}) {
  const sheetOpen = useAnySheetOpen();
  const safeTabs = Array.isArray(tabs) ? tabs : [];
  if (sheetOpen || safeTabs.length === 0) return null;

  return (
    <FloatingBottomNav
      items={safeTabs}
      activeId={activeTab}
      onSelect={onChange}
      accent={ACCENT_VAR[accent] || ACCENT_VAR.online}
      dark={dark}
      swipeProgress={swipeProgress}
    />
  );
}
